
  var _styles = {
  "super-group-goods-item__root-wrapper": {
    "display": "flex",
    "width": "9.52rem",
    "padding": "0.24rem",
    "borderRadius": "0.32rem",
    "background": "#fff",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "stretch",
    "overflow": "visible"
  },
  "super-group-goods-item__left-wrapper": {
    "width": "2.61333rem",
    "marginRight": "0.21333rem",
    "alignItems": "stretch",
    "position": "relative",
    "overflow": "visible"
  },
  "super-group-goods-item__goods-img": {
    "display": "flex",
    "flex": 1,
    "width": "2.61333rem",
    "borderRadius": "0.16rem",
    "overflow": "hidden"
  },
  "super-group-goods-item__ranking-cntr": {
    "width": "0.69333rem",
    "height": "0.82667rem",
    "position": "absolute",
    "left": "0.16rem",
    "top": "-0.08rem"
  },
  "super-group-goods-item__ranking-img": {
    "width": "0.69333rem",
    "height": "0.82667rem"
  },
  "super-group-goods-item__ranking-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "Meituan Digital Type",
    "fontWeight": "700",
    "fontSize": "0.33333rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center",
    "position": "absolute",
    "top": "0.24rem",
    "width": "100%"
  },
  "super-group-goods-item__bottom-tag-img": {
    "position": "absolute",
    "left": 0,
    "bottom": 0
  },
  "super-group-goods-item__right-wrapper": {
    "width": "6.22667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "super-group-goods-item__name": {
    "marginBottom": "0.16rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "textAlign": "left"
  },
  "super-group-goods-item__info-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "marginBottom": "0.16rem"
  },
  "super-group-goods-item__info-left-wrapper": {
    "background": "rgba(0,64,153,.2)",
    "marginRight": "0.10667rem",
    "height": "0.4rem",
    "borderRadius": "0.21333rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "super-group-goods-item__rate-wrapper": {
    "height": "0.4rem",
    "background": "#004099",
    "borderRadius": "0.21333rem 0 0.21333rem 0.21333rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "super-group-goods-item__rate-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "700",
    "fontSize": "0.32rem",
    "textAlign": "center"
  },
  "super-group-goods-item__review-wrapper": {
    "height": "0.4rem",
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "super-group-goods-item__review-text": {
    "color": "rgb(0,64,153)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "super-group-goods-item__position-text": {
    "maxWidth": "5rem",
    "fontWeight": "400",
    "color": "rgb(0,64,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "super-group-goods-item__gift-list-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "super-group-goods-item__gift-item-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "marginBottom": "0.16rem"
  },
  "super-group-goods-item__gift-item-img": {
    "width": "0.4rem",
    "height": "0.4rem",
    "borderRadius": "0.2rem",
    "marginRight": "0.08rem"
  },
  "super-group-goods-item__gift-item-text": {
    "maxWidth": "5.73333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "left"
  },
  "super-group-goods-item__progress-wrapper": {
    "marginTop": "0.16rem"
  },
  "super-group-goods-item__price-wrapper": {
    "marginTop": "0.16rem",
    "width": "6.21333rem",
    "height": "1.17333rem",
    "borderRadius": "0.58667rem",
    "background": "#fff1f0",
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "super-group-goods-item__price-left-wrapper": {
    "width": "4.25333rem",
    "height": "1.17333rem",
    "paddingLeft": "0.32rem",
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start",
    "paddingTop": "0.05333rem"
  },
  "super-group-goods-item__price-info-wrapper": {
    "width": "100%",
    "height": "0.68rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "flex-end",
    "overflow": "visible"
  },
  "super-group-goods-item__sell-price-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "flex-end",
    "overflow": "visible",
    "height": "0.68rem",
    "marginRight": "0.04rem"
  },
  "super-group-goods-item__original-price-wrapper": {
    "display": "flex",
    "height": "0.68rem",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "flex-end",
    "overflow": "visible",
    "paddingBottom": "0.08rem"
  },
  "super-group-goods-item__price-promotion-text": {
    "marginTop": "-0.10667rem",
    "maxWidth": "3.86667rem",
    "fontWeight": "400",
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem"
  },
  "super-group-goods-item__price-right-wrapper": {
    "width": "1.96rem",
    "height": "1.17333rem",
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "super-group-goods-item__price-icon": {
    "width": "1.96rem",
    "height": "1.17333rem",
    "position": "absolute",
    "zIndex": 1,
    "right": 0,
    "top": 0
  },
  "super-group-goods-item__price-button-text": {
    "maxWidth": "1.96rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem",
    "textAlign": "center",
    "marginBottom": "0.05333rem"
  },
  "super-group-goods-item__price-button-extra-text": {
    "marginTop": "-0.13333rem",
    "maxWidth": "1.46667rem",
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  